module.exports = __webpack_public_path__ + "static/img/IMG_20160225_111548.32ce8f20.jpg";